import { appConfig } from './app/app.config';
import { bootstrapApplication } from '@angular/platform-browser';
import { AppComponent } from './app/app.component';

declare const ngDevMode: any;

// const start = performance.now();

bootstrapApplication(AppComponent, appConfig).then(() => {
    if (ngDevMode) {
      console.log('ngDevMode', ngDevMode);
    }
    // const marker = document.querySelector('[data-prerender-marker]');
    // if (marker) {
    //   console.log('[Xedoom] ✅ Marker still exists – DOM was likely hydrated');
    // } else {
    //   console.warn('[Xedoom] ❌ Marker missing – Angular re-rendered the DOM');
    // }
    // console.log(`[Xedoom] Angular bootstrapped in ${(performance.now() - start).toFixed(2)}ms`);
  })
  .catch(err => console.error(err));
